// import Duplicates from './components/ReviewerComponents/Duplicates';


import {DUPLICATES_ROUTE, IMPORTANT_ROUTE, IMPORTANT_UP_ROUTE, CATEGORIES_ROUTE, NEWS_ROUTE, NEWS_WITH_DATE_ROUTE, FILTERS_ROUTE, HOMEPAGE_ROUTE, LOGIN_ROUTE} from "./utils/consts";
import RevDupPage from './pages/Review/Duplicates/Page';
import RevImpPage from './pages/Review/Importance/Page';
import NewsPage from './pages/News/Page';
import FiltersPage from './pages/Filters/Page';

import CategoriesPage from './pages/Review/Categories/Page';
import HomePage from './pages/HomePage';
import Login from './components/Login/Login';

export const userRoutes = [
    {
        path: NEWS_ROUTE,
        Component: <NewsPage />
    },
    {
        path: NEWS_WITH_DATE_ROUTE,
        Component: <NewsPage />
    },
    {
        path: FILTERS_ROUTE,
        Component: <FiltersPage />
    },
]

export const reviewerRoutes = [
    {
        path: DUPLICATES_ROUTE,
        Component: <RevDupPage />
    },
    {
        path: IMPORTANT_ROUTE,
        Component: <RevImpPage />
    },
    {
        path: CATEGORIES_ROUTE,
        Component: <CategoriesPage />
    },
]

export const publicRoutes = [
    {
        path: LOGIN_ROUTE,
        Component: <Login />
    },
    {
        path: HOMEPAGE_ROUTE,
        Component: <HomePage />
    },
]
